import { useMutation } from '@tanstack/react-query';
import { ConfigReader } from '../../../config/ConfigReader';
import { Stage } from '../../../config/ApplicationConfig';
import {
  InfluencerCommissionClient,
  RunInfluencerCommissionRequest,
} from '../../../infrastructure/InfluencerCommissionClient';

export const useInfluencerCommissionRun = () => {
  const config = ConfigReader.getInstance().getConfig();
  const client = new InfluencerCommissionClient(config.apiUrl);

  // Production always keeps the 7-day hold, so the override only makes sense elsewhere.
  const canOverrideHold = config.stage !== Stage.PROD;

  const runMutation = useMutation({
    mutationFn: (request: RunInfluencerCommissionRequest) => client.run(request),
  });

  return {
    runCommission: runMutation.mutate,
    isRunningCommission: runMutation.isPending,
    commissionRunResult: runMutation.data,
    commissionRunError: runMutation.error,
    canOverrideHold,
  };
};
